var _excluded = ["sendEvent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useCallback, useMemo } from 'react';
import { AnalyticsContext } from './analytics-context';
import { buildSendEvent } from './utils/build-send-event';
import { useDebugConsole } from './utils/use-debug-console';
import { jsx as ___EmotionJSX } from "@emotion/core";
var eventStyle = 'color:darkgreen;font-weight:bold';
var boundaryStyle = 'color:darkorange;font-weight:bold';
export var EventBoundary = _ref => {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    children = _ref.children,
    overrideSendEvent = _ref.sendEvent,
    debugProp = _ref.debug,
    loggerProp = _ref.logger;
  var _useDebugConsole = useDebugConsole({
      logger: loggerProp,
      debug: debugProp
    }),
    logger = _useDebugConsole.logger,
    debug = _useDebugConsole.debug;
  var _useContext = useContext(AnalyticsContext),
    sendEvent = _useContext.sendEvent,
    context = _objectWithoutProperties(_useContext, _excluded);
  var isAugmented = name || data && Object.keys(data).length > 0;
  var memoedSendEvent = useCallback((eventName, eventData) => {
    if (isAugmented) {
      logger.info("%cfe-co-analytics: eventBoundary: augmenting event %c".concat(eventName, "%c, payload ").concat(JSON.stringify(eventData), " with %c").concat(name, "%c").concat(data ? " ".concat(name ? 'and ' : '', "payload") : ''), '', eventStyle, '', name ? boundaryStyle : '', '', data);
    } else {
      logger.info("%cfe-co-analytics: eventBoundary: passing on event %c".concat(eventName, "%c unchanged with payload"), '', eventStyle, '', eventData);
    }
    return buildSendEvent(overrideSendEvent || sendEvent)(name, data)(eventName, eventData);
  }, [overrideSendEvent, sendEvent, name, data, isAugmented, logger]);
  var providerValue = useMemo(() => _objectSpread(_objectSpread({}, context), {}, {
    sendEvent: memoedSendEvent,
    logger,
    debug
  }), [context, memoedSendEvent, logger, debug]);
  return ___EmotionJSX(AnalyticsContext.Provider, {
    value: providerValue
  }, children);
};